import React from 'react';
import { Card, Typography, Box } from '@mui/material';
import { Embryo } from './EmbryoGradingAi.helper';
import styles from './EmbryoGradingAI.module.css';
import { useTranslation } from 'react-i18next';

export interface EmbryoListItemProps {
  embryo: Embryo;
  onClick?: () => void;
}

const headerSx = {
  fontFamily: 'Montserrat',
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '145%',
  letterSpacing: 0
};

const subHeaderSx = {
  fontFamily: 'Montserrat',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '145%',
  letterSpacing: 0,
  color: '#9E9E9E'
};

const embryoBoxSx = {
  width: 48,
  height: 48,
  borderRadius: 2, // Rounded corners but square shape
  overflow: 'hidden',
  flexShrink: 0,
  bgcolor: '#E8E8E8',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const EmbryoListItem: React.FC<EmbryoListItemProps> = ({
  embryo,
  onClick,
}) => {

  const { t: tAiGrading } = useTranslation('aiGrading_config');
  const embryoSx = {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    p: 1,
    mb: 1.5,
    borderRadius: 4,
    border: embryo.selected ? '1.5px solid #F3CBC0' : '1px solid #E6E6E6',
    boxShadow: embryo.selected ? '0 2px 8px 0 #E17E6129' : 'none',
    background: embryo.selected ? '#E17E611A' : '#fff',
    cursor: 'pointer',
    transition: 'box-shadow 0.2s, border 0.2s',
    width: '100%'
  };

  return (
    <Card
      onClick={onClick}
      elevation={0}
      sx={embryoSx}
    >
      
      <Box
        sx={embryoBoxSx}
      >
        <img
          src={embryo.avatarUrl}
          alt={`${embryo.embryoNumber}`}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Box>

      <Box sx={{ flex: 1 }}>
        <Typography sx={headerSx} mb={0.5} mt={0.5} >
          {typeof embryo.grade === 'number' ? embryo.grade.toFixed(2) : embryo.grade}
        </Typography>
        <Typography sx={subHeaderSx} mb={0.5}>
          {tAiGrading('embryoId')}:  <span className={styles.dropDownvalueSx}>{embryo.embryoNumber}</span> 
        </Typography>        
      </Box>
    </Card>
  );
};

export default EmbryoListItem;
